import { INTEGER, STRING, BOOLEAN, DATE, FLOAT, DATETIME } from './attribute_type';
 
const DBF_FIELD_LENGTH = 32;

//DBF File descriptor: http://www.clicketyclick.dk/databases/xbase/format/dbf.html

const DFB_FIELD_TYPE = {
	// Character
	"C": STRING,
	// Number
	"N": INTEGER,
	// Logical
	"L": BOOLEAN,
	// Date
	"D": DATE,
	// Float
	"F": FLOAT,
	// Timestamp,
	"@": DATETIME	
}
    
const getDbfType = ( name, type ) => {
    if( DFB_FIELD_TYPE.hasOwnProperty(type) ) {
    	return DFB_FIELD_TYPE[type]
    } else {
    	console.warn("Unknown DBF type: ", name, type);
    }
}	

class DBFField {
	constructor(name, type) {
		this.name = name;
		this.type = type;
	}
	
	getName() {
		return this.name;
	}
	
	getPropertyType() {
		return this.type;
	}
	
}

class DBFReader {
	constructor(dataView, numberOfFields) {
		this.dataView = dataView;
		this.numberOfFields = numberOfFields;
	}
	
	readString(offset, length) {
        let s = "";
        for (let i = offset, l = offset + length; i < l; i++) {
        	const charCode = this.dataView.getUint8(i);
        	if( charCode > 0x0 ) {        	
            	s += String.fromCharCode(charCode);
            }
        }

        return s;
    }
	
	read() {    	
		const fields = [];
	
        for (let i = 0; i < this.numberOfFields; i++) {
            const name = this.readString(i * DBF_FIELD_LENGTH, 10);
            let type = String.fromCharCode(this.dataView.getUint8((i * DBF_FIELD_LENGTH) + 11));
            const decimals = this.dataView.getUint8((i * DBF_FIELD_LENGTH) + 17);
            
            if( type.toUpperCase() === "N" && decimals > 0 ) {
                type = "F";
            }
            
            const propertyType = getDbfType(name, type);             
            fields.push( new DBFField( name, propertyType ) );
        }
        
        return fields;
    }
}

const getNumberOfFields = async (reader) => {
	const buffer = await reader.read(0, DBF_FIELD_LENGTH);
	
	// parse first bytes 
	const littleEndian = true;
		        
	const dataView = new DataView(buffer);
    const validDbf = dataView.getUint8(0) == 3;
	let headerSize = -1;

    if (validDbf) {
    	headerSize = dataView.getUint16(8, littleEndian);
    } else {
    	console.log("Invalid DBF File: " + dataView.getUint8(0));
    }
	
	const fields = (headerSize - DBF_FIELD_LENGTH - 1) / DBF_FIELD_LENGTH; 
    return {
    	fields: fields,
    	headerSize: headerSize
    }       
}

const dbf = async (reader) => {
	const { fields, headerSize } = await getNumberOfFields( reader );

	if( fields > 0 ) {
		const buffer = await reader.read(DBF_FIELD_LENGTH, headerSize);
		const dataView = new DataView(buffer);
		
		const dbfReader = new DBFReader(dataView, fields);
		return dbfReader.read();		
	}
}

export {
	dbf
}